import { Flex, IconButton, TextV2, styled } from '@withjoy/joykit';
import React, { useState } from 'react';
import { PlusIcon } from './Plus';
import { useTranslation } from '@shared/core';

// Styled component for AddPillButton wrapper
const StyledAddPillButtonWrapper = styled(Flex)<{ isHovered: boolean }>`
  align-items: center;
  gap: 8px;
  background-color: ${({ isHovered }) => (isHovered ? 'var(--mono-2-bg, #F7F7F7)' : 'transparent')};
  transition: background-color 0.1s ease;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 9999px;

  user-select: none;

  &:active {
    background-color: #e0e0e0;
  }
`;

const AddPillButton = (props: { onClick?: () => void }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { tq } = useTranslation('generalEventScheduleEditor');

  return (
    <StyledAddPillButtonWrapper
      isHovered={isHovered}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={props.onClick}
    >
      <IconButton
        height="fit-content"
        aria-label="Add"
        variant="ghost"
        minWidth={0}
      >
        <PlusIcon />
      </IconButton>
      <TextV2
        style={{
          opacity: isHovered ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
        typographyVariant="button2"
        color="#4951EF"
      >
        {tq`Add Event`}
      </TextV2>
    </StyledAddPillButtonWrapper>
  );
};

type DayGroupProps = {
  title: string;
  subtitle?: string;
  onAddClick?: () => void;
  children?: React.ReactNode;
};

export const DayGroup = (props: DayGroupProps) => {
  const { title, subtitle, children, onAddClick } = props;

  return (
    <Flex
      gap="8px"
      flexDirection="column"
      cursor="pointer"
      userSelect="none"
    >
      <Flex
        paddingX="16px"
        justifyContent="space-between"
        alignItems="center"
      >
        <TextV2 typographyVariant="hed3">{title}</TextV2>
        {subtitle && <TextV2 typographyVariant="label2">{subtitle}</TextV2>}
      </Flex>
      {children}
      {onAddClick && (
        <Flex
          alignItems="center"
          justifyContent="flex-start"
        >
          <AddPillButton onClick={onAddClick} />
        </Flex>
      )}
    </Flex>
  );
};
